import { render, staticRenderFns } from "./mixin.vue?vue&type=template&id=9feaa67c&scoped=true&"
import script from "./mixin.vue?vue&type=script&lang=js&"
export * from "./mixin.vue?vue&type=script&lang=js&"
import style0 from "./mixin.vue?vue&type=style&index=0&id=9feaa67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feaa67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9feaa67c')) {
      api.createRecord('9feaa67c', component.options)
    } else {
      api.reload('9feaa67c', component.options)
    }
    module.hot.accept("./mixin.vue?vue&type=template&id=9feaa67c&scoped=true&", function () {
      api.rerender('9feaa67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/mixin.vue"
export default component.exports